<template>
  <div class="d-flex mb-3">
    <!-- Right Section: Form Content -->
    <div class="d-flex flex-column justify-content-center align-items-center w-100">
      <div class="border-0 text-dark w-75 p-4 overflow-auto">
        <h1 class="mb-4">Υποστήριξη Εφαρμογής</h1>

        <h2 class="fs-4 py-3">Καλώς ήρθατε στη σελίδα υποστήριξης της εφαρμογής μας.</h2>
        
        <p>Εάν αντιμετωπίζετε προβλήματα με την εφαρμογή, έχετε προτάσεις για βελτιώσεις ή θέλετε να επικοινωνήσετε μαζί μας για οποιοδήποτε θέμα σχετικό με τη χρήση της εφαρμογής, παρακάτω θα βρείτε τις απαραίτητες πληροφορίες επικοινωνίας.</p>
        
        <h3 class="fs-4 py-3">Επικοινωνία</h3>
        <p>
          Δήμος Νέας Ιωνίας<br>
          Νέα Ιωνία 142 34,<br>
          Αττική, Ελλάδα
        </p>
        <p class="fw-bold">
          Email Υποστήριξης: info@neaionia.gr
        </p>
        <h4 class="py-3">Συχνές Ερωτήσεις (FAQ)</h4>
        <h5 class="fw-bold">Δεν μπορώ να συνδεθώ στην εφαρμογή. Τι να κάνω;</h5>
        <p>Παρακαλούμε βεβαιωθείτε ότι χρησιμοποιείτε τα σωστά στοιχεία σύνδεσης. Αν το πρόβλημα συνεχιστεί, επικοινωνήστε μαζί μας στο email υποστήριξης.</p>
        <h5 class="fw-bold">Πού μπορώ να δω την Πολιτική Απορρήτου;</h5>
        <p>Η πολιτική απορρήτου είναι διαθέσιμη <a href="/terms-and-conditions" style="color: #AF0036"><b>εδώ</b></a>.</p>
      </div>
    </div>
  </div>
</template>


  
  <script>

  </script>
  
  <style scoped>
  
  </style>
  